import { Box } from 'vopay';
import { Skeleton } from 'UI';

export default function PreFundingSettingsSkeleton() {
  return (
    <Box flx="col" gapSize="12px">
      <Skeleton height={78} borderRadius={10} count={3} style={{ marginBottom: '12px' }} />

      <Box mt="sm" ai="center" gapSize="8px">
        <Skeleton width={90} height={18} />
      </Box>

      <Skeleton height={32} width={260} borderRadius={8} />
    </Box>
  );
}
